"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseStatus = void 0;
var CaseStatus;
(function (CaseStatus) {
    CaseStatus["Approved"] = "Approved";
    CaseStatus["AwaitingCustomerFeedback"] = "Awaiting Customer Feedback";
    CaseStatus["AwaitingPhotos"] = "Awaiting Photos";
    CaseStatus["AwaitingReturn"] = "Awaiting Return";
    CaseStatus["Closed"] = "Closed";
    CaseStatus["Declined"] = "Declined";
    CaseStatus["InProgress"] = "In Progress";
    CaseStatus["New"] = "New";
    CaseStatus["WaitingForApproval"] = "Waiting for Approval";
    CaseStatus["Error"] = "error";
    CaseStatus["FailedToSubmitReturn"] = "failed_to_submit_return_order";
    CaseStatus["NotSubmitted"] = "not_submitted";
    CaseStatus["Submitting"] = "submitting";
    CaseStatus["Retry"] = "retry";
    CaseStatus["MaxRetryReached"] = "max_retry_reached";
})(CaseStatus = exports.CaseStatus || (exports.CaseStatus = {}));
//# sourceMappingURL=case-status.enum.js.map